/* eslint-disable react/no-children-prop */
import { themeStore } from "@/stores/theme";
import { useTranslate } from "@/utils/lang";
import { AlbumWords } from "@/utils/lang/album";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  InputGroup,
  Input,
  InputRightElement,
  Flex,
  Button,
  useBoolean,
  Text,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { albumStore } from "../store";
import { OpModalBaseProps } from "../type";

type CreateModalProps = OpModalBaseProps & {
  onCreate?: () => void;
};

function CreateModal(props: CreateModalProps) {
  const { panelBg, boardBg } = themeStore.styles;
  const { isOpen, onClose, onCreate, store = albumStore } = props;
  const [loading, setLoading] = useBoolean(false);
  const [albumName, setAlbumName] = useState("");
  const { translate } = useTranslate();

  const handleClose = () => {
    setAlbumName("");
    onClose();
  };

  const handleAlbumNameChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    const name = e.target.value.slice(0, 20);
    setAlbumName(name);
  };
  const handleConfirmAlbumName: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
    setLoading.on();
    await store
      .addAlbum(albumName)
      .then(handleClose)
      .catch(() => void 0)
      .finally(setLoading.off);
    onCreate?.();
  };
  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <ModalOverlay />
      <ModalContent bg={panelBg} w="716px" mt="278px">
        <ModalHeader color="white" textAlign="center" pt="40px" fontSize="32px">
          {translate(AlbumWords.newAlbum)}
        </ModalHeader>
        <ModalCloseButton color="white" />
        <ModalBody px="88px">
          <Text color="white" mb="16px" fontSize="20px">
            {translate(AlbumWords.createAlbumModalInputTitle)}
          </Text>
          <InputGroup color="#999999">
            <Input
              placeholder={translate(AlbumWords.createAlbumModalInputPlaceholder)}
              maxLength={20}
              value={albumName}
              bg={boardBg}
              borderColor="#585858"
              onChange={handleAlbumNameChange}
            />
            <InputRightElement children={`${albumName.length}/20`} mr="8px" />
          </InputGroup>
          <Flex justify="center" mt="58px" mb="48px">
            <Button variant="dark.solid" w="140px" mr="14px" onClick={handleClose}>
              {translate(AlbumWords.cancel)}
            </Button>
            <Button
              variant="primary"
              w="140px"
              disabled={!albumName || loading}
              isLoading={loading}
              loadingText={translate(AlbumWords.creatingAlbum)}
              onClick={handleConfirmAlbumName}
            >
              {translate(AlbumWords.newAlbum)}
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export const CreateAlbumModal = observer(CreateModal);
